import {useFilteredParticipants} from './useFilteredParticipants';

/**
 * Returns the participants filtered by favorites for a given event.
 *
 * @param {number} eventId - The ID of the event.
 * @return {Array} An array of participants filtered by favorites.
 */
export function useFavoritedParticipants(eventId) {
    return useFilteredParticipants(eventId, {
        favorites: true,
    })[0];
}
